import { useAuthStore } from '../zustand/authentication/use-auth-store'

export default function tokenExpiredMiddleware() {
  const setExpiredToken = useAuthStore?.getState().setExpiredToken

  return (dispatch) => (action) => {
    if (/_ERROR$/.test(action.type)) {
      if (
        action.error &&
        action.error.response &&
        action.error.response.status === 401
      ) {
        if (
          action.error.response.data &&
          action.error.response.data.error === 'invalid_token' &&
          action.error.response.data.error_description.includes(
            'Access token expired:'
          )
        ) {
          setExpiredToken(true)
        }
      }
    }
    dispatch(action)
  }
}
